import React, { useEffect, useState } from "react";
import styled, { css, keyframes } from "styled-components";

// Muuri
import MuuriGrid from "muuri";
import "./style.css";
import PlaylistService from "../../../service/playlist-service";
import ToastService from "../../../service/toast-service";

// icons
import MaterialIconButton from "@material-ui/core/IconButton";
import { faHeart as faEmptyHeart } from "@fortawesome/free-regular-svg-icons";
import {
  faPlay,
  faTimes,
  faEllipsisV,
  faCaretDown,
  faPlus,
  faList,
  faHeart,
  faCheck,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Theme } from "../../../theme/theme-provider";
// some comps
import { Box, Row, Text, HGap, Img, Fab, OptionButton } from "../../../comps";

const ListWrapper = styled(Box)`
  width: 100%;
  padding-left: 30px;
  padding-right: 30px;
  @media ${({ theme }) => theme.screenSize.portrait} {
    padding-left: 10px;
    padding-right: 10px;
  }
`;

const GridItem = styled(Box)`
  height: 60px;
  width: 100%;
`;

const SongWrapper = styled(Row)`
  width: 100%;
  height: 100%;
  align-items: center;
  margin: 5px;
  padding-left: 40px;
  padding-right: 40px;
  @media ${({ theme }) => theme.screenSize.portrait} {
    padding-left: 10px;
    padding-right: 10px;
  }
  border-bottom: 1px solid ${({ theme }) => theme.color.GRAY_1};
  &:hover {
    background: #45413d;
  }
`;

const PlayButton = styled(Box)`
  display: none;
  ${SongWrapper}:hover & {
    display: block;
  }
`;

const SingleItem = ({ song, isModalView, handleAddSongs }) => {
  const { videoId, title, thumbnails } = song;
  const { mediumUrl, StandardUrl } = thumbnails;
  const [isAdded, setIsAdded] = useState(false);

  const addSong = async () => {
    if (!isAdded) {
      const added = await handleAddSongs([song]);
      setIsAdded(added);
    }
  };

  return (
    <GridItem className={"item"}>
      <div class="item-content">
        <SongWrapper>
          <Img width={80} height={45} src={mediumUrl} />
          <Text
            oneline={true}
            width="50%"
            fontSize={"16px"}
            fontWeight={300}
            marginLeft={"6%"}
          >
            {title}
          </Text>
          <HGap style={{ marginLeft: "auto" }} width="0px" />
          {!isModalView && (
            <PlayButton>
              <Fab
                faIcon={faPlay}
                backgroundColor={Theme.color.BLUE_4}
                iconColor="#fff"
                elevation={false}
              />
            </PlayButton>
          )}
          {!isModalView && <HGap width="5%" />}
          {!isModalView && (
            <OptionButton
              optionBackground={Theme.color.BLUE_4}
              isIconButton={true}
              color="#fff"
              icon={faEllipsisV}
              style={{ marginLeft: "5%" }}
              options={[
                { icon: faList, text: "Add To Queue", onClick: () => {} },
                {
                  icon: faPlus,
                  text: "Add To Playlist",
                  onClick: () => {
                    ToastService.infoToast("creating new playlist");
                    PlaylistService.createNewPlaylist([
                      { videoId, title, thumbnails },
                    ]);
                  },
                },
              ]}
            />
          )}

          {!isModalView && (
            <MaterialIconButton style={{ marginLeft: "5%" }}>
              <FontAwesomeIcon
                style={{ fontSize: "16px", color: Theme.color.BLUE_4 }}
                icon={faHeart}
              />
            </MaterialIconButton>
          )}
          {isModalView && (
            <MaterialIconButton style={{ marginLeft: "5%" }} onClick={addSong}>
              <FontAwesomeIcon
                style={{ fontSize: "16px", color: Theme.color.WHITE_2 }}
                icon={isAdded ? faCheck : faPlus}
              />
            </MaterialIconButton>
          )}
        </SongWrapper>
      </div>
    </GridItem>
  );
};

export default ({ songs, handleAddSongs, isModalView }) => {
  useEffect(() => {
    const resultGrid = new MuuriGrid(".importModalgrid", {
      dragEnabled: true,
      layout: { fillGaps: true, alignLeft: true, alignTop: true },
    });
  },[songs]);
  return (
    <ListWrapper>
      <div class="grid importModalgrid">
        {songs.map((song) => {
          return (
            <SingleItem
              song={song}
              handleAddSongs={handleAddSongs}
              isModalView={isModalView}
            />
          );
        })}
      </div>
    </ListWrapper>
  );
};
